<template lang="pug">
    div.work-order-maintenance-add.content-common-margin(
        v-if="getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderCreate')"
        v-loading="loading"
    )
        header-title(
            title="创建保养工单"
            backRouteName="MaintenanceWorkOrderIndex"
        )
        div.work-order-maintenance-add-content
            el-form.form(
                :model="formData"
                :rules="rules"
                ref="form"
                label-width="130px"
            )
                el-form-item(
                    label="联系人姓名:"
                    prop="contactName"
                )
                    el-input.input-width(
                        v-model.trim="formData.contactName"
                        placeholder="请输入"
                        maxlength="20"
                        clearable
                    )
                el-form-item(
                    label="联系人手机号:"
                    prop="contactPhone"
                )
                    el-input.input-width(
                        v-model.trim="formData.contactPhone"
                        placeholder="请输入"
                        maxlength="11"
                        clearable
                    )
                el-form-item(
                    label="车架号:"
                    prop="vin"
                )
                    el-input.input-width(
                        v-model.trim="formData.vin"
                        placeholder="请输入"
                        maxlength="17"
                        clearable
                        :disabled="vinDisabled"
                        @blur="vinBlur"
                        @clear="vinClear"
                    )
                el-form-item(
                    label="车型:"
                    prop="vehicleInfo"
                )
                    //- :disabled="vehicleDisabled"
                    el-select.input-width(
                        v-model="formData.vehicleInfo"
                        value-key="label"
                        placeholder="请选择"
                        clearable
                    )
                        el-option(
                            v-for="(item, index) in vehicleOptions"
                            :key="index"
                            :label="item.label"
                            :value="item"
                        )
                        div.add-vehicle(
                            @click="handleAddVehicle"
                        )
                            i.el-icon-plus
                            span 添加车型
                        div.add-vehicle(
                            @click="handleAddVehicle"
                            slot="empty"
                        )
                            i.el-icon-plus
                            span 添加车型
                el-form-item(
                    v-if="purchaseDateDisabled"
                    label="购车日期:"
                    prop="purchaseDate"
                )
                    el-date-picker.input-width(
                        v-model="formData.purchaseDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        placeholder="请选择"
                        :editable="false"
                    )
                el-form-item(
                    label="当前里程(km):"
                    prop="currentMileage"
                )
                    el-input.input-width(
                        v-model.trim="formData.currentMileage"
                        maxlength="7"
                        placeholder="请输入"
                        clearable
                    )
                el-form-item(
                    label="车牌号码:"
                    prop="plateNumber"
                )
                    //- :disabled="plateDisabled"
                    el-input.input-width(
                        v-model.trim="formData.plateNumber"
                        placeholder="请输入"
                        maxlength="8"
                        clearable
                    )
                el-form-item.special(
                    label="选择预约单:"
                    prop="bookingOrderId"
                )
                    div.remain 选择已有预约信息
                    booking-order-select(:vin="formData.vin" :order-id="orderId" :order-type="'MAINTAIN'" @selectOrder="selectBookingOrder")
            div.footer
                el-button.submit-button(
                    round
                    @click="handleCancel"
                ) 取消
                el-button.submit-button(
                    round
                    type="primary"
                    :loading="loading"
                    @click="handleSubmit"
                ) 确认创建
        add-vehicle(
            v-if="addVehicleData.show"
            :addVehicleData="addVehicleData"
            @addVehicle="addVehicleOptions"
        )
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import HeaderTitle from '@/components/HeaderTitle.vue';
import { workOrderApis, appointmentApis, vehicleApis } from '@/api';
import AddVehicle from '@/components/workOrder/AddVehicle.vue';
import BookingOrderSelect from '@/components/workOrder/BookingOrderSelect.vue';

export default {
    name: 'MaintenanceWorkOrderCreate',
    components: {
        HeaderTitle,
        AddVehicle,
        BookingOrderSelect,
    },
    data() {
        const validateMileage = (rule, value, callback) => {
            if (value > 1000000) {
                callback(new Error('最大里程不能超过1000000km'));
            } else {
                callback();
            }
        };
        const validateVin = (rule, value, callback) => {
            const regexp = /^[0-9A-HJ-NPR-Z]{17}$/;
            if (value && !regexp.test(value)) {
                callback(new Error('车架号格式不正确'));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            purchaseDateDisabled: false,
            vehicleOptions: [],
            addVehicleData: {
                show: false,
            },
            formData: {
                contactPhone: '',
                contactName: '',
                vehicleBrand: null,
                vehicleSeries: null,
                vehicleModel: null,
                vehicleInfo: null,
                purchaseDate: null,
                plateNumber: '',
                vin: '',
                currentMileage: null,
                bookingOrderId: '',
                orderType: 'MAINTAIN',
            },
            rules: {
                contactPhone: [
                    {
                        required: true,
                        message: '请输入联系人手机号',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/,
                        message: '请输入正确的手机号',
                        trigger: 'blur',
                    },
                ],
                contactName: [
                    {
                        required: true,
                        message: '请输入联系人姓名',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[\u4e00-\u9fa5a-zA-Z]*$/,
                        message: '请输入正确的姓名',
                        trigger: 'blur',
                    },
                ],
                vehicleInfo: [
                    {
                        required: true,
                        message: '请选择车辆型号',
                        trigger: 'change',
                    },
                ],
                purchaseDate: [
                    {
                        required: true,
                        message: '请选择购车日期',
                        trigger: 'change',
                    },
                ],
                plateNumber: [
                    {
                        required: true,
                        message: '请输入车牌号',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[\u4E00-\u9FA5A-Za-z0-9]+$/,
                        message: '请输入正确的车牌号',
                        trigger: 'blur',
                    },
                ],
                vin: [
                    {
                        required: true,
                        message: '请输入车架号',
                        trigger: 'blur',
                    },
                    {
                        validator: validateVin,
                        trigger: 'blur',
                    },
                ],
                currentMileage: [
                    {
                        required: true,
                        message: '请输入当前里程',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^([1-9][0-9]*)$/,
                        message: '请输入正确的里程',
                        trigger: 'blur',
                    },
                    {
                        validator: validateMileage,
                        trigger: 'blur',
                    },
                ],
            },
            orderId: '',
            arriveTime: '',
            // 新增表单判断逻辑
            plateDisabled: false,
            vehicleDisabled: false,
            vinDisabled: false,
            oldVin: '',
        };
    },
    computed: {
        ...mapGetters('user', [
            'getAuthority',
        ]),
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            const myVm = vm;
            const pathQuery = myVm.$route.query;
            if (pathQuery.orderId && (pathQuery.orderId !== myVm.orderId || pathQuery.arriveTime !== myVm.arriveTime)) {
                myVm.orderId = pathQuery.orderId;
                myVm.arriveTime = pathQuery.arriveTime;
                myVm.getAppointmentOrderInfo(pathQuery.orderId);
            }
        });
    },
    methods: {
        async getAppointmentOrderInfo(id) {
            try {
                this.loading = true;
                const { data } = await appointmentApis.getOrderDetail(id);
                const orderData = {
                    contactPhone: data.phone || '',
                    contactName: data.name || '',
                    vehicleBrand: data.vehicleBrand || '',
                    vehicleSeries: data.vehicleSerial || '',
                    vehicleModel: data.vehicleType || '',
                    vehicleInfo: {
                        label: data.vehicleBrand ? `${data.vehicleBrand || ''}${data.vehicleSerial || ''}${data.vehicleType || ''}` : '',
                        plateNumber: data.vehicleInfos.plateNumber || '',
                        vehicleBrand: data.vehicleBrand || '',
                        vehicleSerial: data.vehicleSerial || '',
                        vehicleType: data.vehicleType || '',
                        vin: data.vehicleInfos.vin || '',
                        vehicleModelId: data.vehicleInfos.vehicleModelId || '',
                    },
                    plateNumber: data.vehicleInfos ? (data.vehicleInfos.plateNumber || '') : '',
                    vin: data.vin || '',
                    currentMileage: data.orderMileage || null,
                    bookingOrderId: data.orderId,
                    orderType: 'MAINTAIN',
                    resourceId: data.orderId,
                    orderSource: 'BOOKING_ORDER',
                    arriveTime: this.arriveTime ? this.$dayjs(this.arriveTime).toISOString() : null,
                };
                this.initFormData(orderData, data.vehicleInfos.vehicleId);
                this.getHasPurchaseDate(data.vin);
            } catch (error) {
                throw new Error(error);
            } finally {
                this.loading = false;
            }
        },
        initFormData(data, vehicleId) {
            this.formData = { ...data };
            this.vehicleOptions.push(data.vehicleInfo);
            if (vehicleId) {
                this.plateDisabled = Boolean(this.formData.plateNumber);
                this.vinDisabled = Boolean(this.formData.vin);
                this.vehicleDisabled = Boolean(this.formData.vehicleInfo.vehicleModelId);
            } else {
                this.plateDisabled = false;
                this.vinDisabled = false;
                this.vehicleDisabled = false;
            }
        },
        handleAddVehicle() {
            this.addVehicleData.show = true;
        },
        addVehicleOptions(obj) {
            this.vehicleOptions = this.vehicleOptions.filter(v => v.vehicleModelId !== obj.vehicleModelId);
            this.vehicleOptions.push(obj);
            this.formData.vehicleInfo = obj;
        },
        selectBookingOrder(orderId) {
            this.formData.bookingOrderId = orderId;
        },
        handleCancel() {
            const {
                navType,
            } = this.$route.query;
            this.$router.push({
                name: 'MaintenanceWorkOrderIndex',
                query: {
                    navType,
                },
            });
        },
        handleSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) return;
                const {
                    vehicleInfo,
                    ...postData
                } = this.formData;
                try {
                    this.loading = true;
                    await workOrderApis.createWorkOrder({
                        ...postData,
                        vehicleBrand: vehicleInfo.vehicleBrand,
                        vehicleSeries: vehicleInfo.vehicleSerial,
                        vehicleModel: vehicleInfo.vehicleType,
                        vehicleModelId: vehicleInfo.vehicleModelId,
                        purchaseDate: this.formData.purchaseDate ? dayjs(this.formData.purchaseDate) : null,
                    });
                    this.$message({
                        message: '新增工单成功',
                        type: 'success',
                    });
                    const {
                        navType,
                    } = this.$route.query;
                    this.$router.push({
                        name: 'MaintenanceWorkOrderIndex',
                        query: {
                            navType,
                        },
                    });
                } catch (err) {
                    throw new Error(err);
                } finally {
                    this.loading = false;
                }
            });
        },
        vinBlur(e) {
            const vin = e.target.value;
            const regexp = /^[0-9A-HJ-NPR-Z]{17}$/;
            if (vin && regexp.test(vin)) {
                this.getVehicle(vin);
                this.getHasPurchaseDate(vin);
            } else {
                this.resetVehicle();
                this.oldVin = '';
            }
        },
        vinClear() {
            this.resetVehicle();
            this.oldVin = '';
        },
        resetVehicle() {
            this.formData.vehicleInfo = null;
            this.formData.plateNumber = '';
            this.formData.purchaseDate = '';
            this.purchaseDateDisabled = false;
            this.plateDisabled = false;
            this.vehicleDisabled = false;
            this.$nextTick(() => {
                this.$refs.form.clearValidate(['vehicleInfo', 'plateNumber', 'purchaseDate']);
            });
        },
        async getHasPurchaseDate(vin) {
            try {
                this.loading = true;
                const { data, code } = await vehicleApis.getHasPurchaseDateByVin({ vin });
                if (code === 0) {
                    this.purchaseDateDisabled = !data;
                }
            } catch (error) {
                throw new Error(error);
            } finally {
                this.loading = false;
            }
        },
        async getVehicle(vin) {
            // 如果两次输入相同车架号，则不重复请求车辆信息
            if (vin === this.oldVin) return;
            this.oldVin = vin;
            try {
                this.loading = true;
                const { data } = await vehicleApis.getVehicleByVin({ vin });
                if (data) {
                    const vehicle = data;
                    const vehicleObj = {
                        label: `${vehicle.vehicleBrand || ''}${vehicle.vehicleSeries || ''}${vehicle.vehicleModel || ''}`,
                        plateNumber: vehicle.plateNumber || '',
                        vehicleBrand: vehicle.vehicleBrand || '',
                        vehicleSerial: vehicle.vehicleSeries || '',
                        vehicleType: vehicle.vehicleModel || '',
                        vin: vehicle.vin || '',
                        vehicleModelId: vehicle.vehicleModelId || '',
                        purchaseDate: vehicle.purchaseDate || '',
                    };
                    this.formData.plateNumber = vehicle.plateNumber || '';
                    this.formData.purchaseDate = vehicle.purchaseDate || '';
                    this.addVehicleOptions(vehicleObj);
                    if (vehicle.vehicleId) {
                        this.plateDisabled = Boolean(vehicle.plateNumber);
                        this.vehicleDisabled = Boolean(vehicle.vehicleModelId);
                    } else {
                        this.plateDisabled = false;
                        this.vehicleDisabled = false;
                    }
                } else {
                    this.resetVehicle();
                }
            } catch (err) {
                throw new Error(err);
            } finally {
                this.loading = false;
                this.$nextTick(() => {
                    this.$refs.form.clearValidate(['vehicleInfo', 'plateNumber']);
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .work-order-maintenance-add {
        height: calc(100% - 50px);
        @include bg_color(color_base_white);
        &-content {
            background-color: #fff;
            padding: 30px 40px;
            .form {
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .input-width {
                width: 490px;
            }
            .footer {
                display: flex;
                flex-direction: row;
                justify-content: center;
                .submit-button {
                    margin: 10px 15px 0 15px;
                    border-radius: 18px;
                }
            }
        }
    }
    .add-vehicle {
        line-height: 34px;
        padding: 0 20px;
        margin: 6px 0;
        cursor: pointer;
        @include font_color(color_base_blue6);
        &:hover {
            @include bg_color(color_base_gray4);
        }
    }
    .remain {
        font-size: 12px;
        color: rgba(0,0,0,0.45);
        line-height: 20px;
        font-weight: 400;
        margin: 6px 0 8px 0;
    }
</style>

<style lang="scss">
    .work-order-maintenance-add {
        .el-input__icon {
            line-height: 32px;
        }
        &-content {
            .special {
                .el-form-item__label {
                    padding-left: 11px;
                }
            }
            .el-checkbox__label {
                @include font_color(text_color_base,!important);
            }
            button {
                width: 110px;
                height: 36px;
                border-radius: 22px;
            }
        }
    }
</style>
